
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Home',
    data() {
        return {
            navs: [
                {
                    label: '休闲游戏',
                    key: 'game'
                }
            ]
        };
    }
});
